import script from "./ClubSignup.vue?vue&type=script&setup=true&lang=js"
export * from "./ClubSignup.vue?vue&type=script&setup=true&lang=js"

import "./ClubSignup.vue?vue&type=style&index=0&id=680b68d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-680b68d2"]])

export default __exports__